import { ActionTypes } from '../actions'

export const rootReducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.TOGGLE_CATEGORY:
      const categoryId = action.payload.categoryId;
      const parentBtn = state.buttons.find(btn => btn.id === categoryId);
      const parentIsBeingEnabled = !parentBtn.checked;

      return {
        ...state,
        buttons: state.buttons.map(btn => {
          if (btn.id === categoryId) {
            return { ...btn, checked: !btn.checked };
          }

          if (!parentIsBeingEnabled && btn.parent_id === categoryId) {
            return { ...btn, checked: false };
          }

          return btn;
        }),
      };

    case ActionTypes.REORDER_SUBCATEGORIES:
      const { reorderedSubcategories } = action.payload;

      return {
        ...state,
        buttons: state.buttons.map(btn => {
          const updatedBtn = reorderedSubcategories.find(sub => sub.id === btn.id);
          return updatedBtn ? updatedBtn : btn;
        }),
      };

    case ActionTypes.REORDER_CATEGORIES:
      return {
        ...state,
        buttons: state.buttons.map(btn => {
          const updated = action.payload.find(cat => cat.id === btn.id);
          return updated ? { ...btn, order_number: updated.order_number } : btn;
        }),
      };

    case ActionTypes.ADD_CATEGORY:
      return {
        ...state,
        buttons: [...state.buttons, action.payload],
      };

    case ActionTypes.UPDATE_CATEGORY:
      return {
        ...state,
        buttons: state.buttons.map(btn =>
          btn.id === action.payload.id ? { ...btn, ...action.payload } : btn
        )
      };

    case ActionTypes.DELETE_CATEGORY:
      return {
        ...state,
        buttons: state.buttons.filter(button =>
          button.id !== action.payload && button.parent_id !== action.payload
        ),
      };

    case ActionTypes.TOGGLE_DIRECTORY:
      return {
        ...state,
        directories: state.directories.map((directory) =>
          (directory.id === action.payload)
            ? { ...directory, mobile_enabled: !directory.mobile_enabled }
            : directory
        ),
      };

    case ActionTypes.INCREMENT_NEXT_TEMP_ID:
      return {
        ...state,
        nextTempId: state.nextTempId + 1,
      }

    case 'REORDER_DIRECTORIES':
      return {
        ...state,
        directories: action.payload,
      };

    default:
      return state;
  }
};

export default rootReducer